import React from 'react'
import styled from 'styled-components'
import ScrollUp from '../components/scrollUp'

const FooterContainer = styled.div`
  margin: 15rem 0 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 2rem 3rem;
  width: 100%;

  @media (max-width: 768px) {
    width: 100%;
    padding: 2rem 1rem;
    flex-direction: column;
    height: 300px;
  }
`

const EndLinks = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 15px;
  /* border-top: 2px solid #ccc; */
`

const EndLink = styled.div`
  justify-content: center;
  width: 100%;
`

const EndLinkLabel = styled.span`
  text-align: left;
  width: 100px;
  display: inline-block;
  color: #4f4f4f;
  opacity: 0.4;
  margin: 0 0.5rem 0 0;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
`

const EndLinkLink = styled.a`
  text-align: left;
  width: 50%;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
  color: #4f4f4f;
  cursor: pointer;
  :visited {
    color: #4f4f4f;
  }
`

class Footer extends React.Component {
  render() {
    return (
      <FooterContainer>
        <EndLinks>
          <EndLink>
            <EndLinkLabel>Email</EndLinkLabel>
            <EndLinkLink mailto="oscareriknilsson@gmail.com">
              oscareriknilsson@gmail.com
            </EndLinkLink>
          </EndLink>
          <EndLink>
            <EndLinkLabel>Twitter</EndLinkLabel>
            <EndLinkLink href="https://www.twitter.com/oscrse">
              @oscrse
            </EndLinkLink>
          </EndLink>
          <EndLink>
            <EndLinkLabel>Instagram</EndLinkLabel>
            <EndLinkLink href="https://www.instagram.com/oscrse">
              @oscrse
            </EndLinkLink>
          </EndLink>
          <EndLink>
            <EndLinkLabel>Pinterest</EndLinkLabel>
            <EndLinkLink href="https://www.pinterest.com/oscrse">
              /oscrse
            </EndLinkLink>
          </EndLink>
          <EndLink>
            <EndLinkLabel>Dribbble</EndLinkLabel>
            <EndLinkLink href="https://www.dribbble.com/oscrse">
              /oscrse
            </EndLinkLink>
          </EndLink>
        </EndLinks>
        <ScrollUp />
      </FooterContainer>
    )
  }
}

export default Footer
